import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Mặc định tiếng Việt; cấu trúc sẵn sàng thêm 'en' về sau.
const resources = {
  vi: {
    translation: {
      appName: 'ERP Tập đoàn tài chính',
      login: {
        title: 'Đăng nhập hệ thống',
        ssoButton: 'Đăng nhập bằng SSO',
        hint: 'Bạn sẽ được chuyển tới trang đăng nhập tập trung (TigerSSO).',
      },
      menu: {
        dashboard: 'Tổng quan',
        approvals: 'Việc cần duyệt',
      },
      common: {
        logout: 'Đăng xuất',
        company: 'Công ty',
      },
    },
  },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'vi',
  fallbackLng: 'vi',
  interpolation: { escapeValue: false },
});

export default i18n;
